module.exports = __webpack_public_path__ + "static/media/not-image.d76658c9.webp";